import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type {
  TaxonomyThemePayload,
  TaxonomyUploadPayload,
} from '../../../services/sentiment-analysis-stats/sentiment-analysis-stats.service';

@Component({
  selector: 'app-sentiment-analysis-taxonomy-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sentiment-analysis-taxonomy-preview.component.html',
  styleUrls: ['./sentiment-analysis-taxonomy-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SentimentAnalysisTaxonomyPreviewComponent {
  @Input() taxonomy: TaxonomyUploadPayload | null = null;
  @Input() title = 'Taxonomy details';
  /** When true, show `taxonomy.mode` under the title. */
  @Input() showMode = true;

  get themes(): TaxonomyThemePayload[] {
    return this.taxonomy?.themes ?? [];
  }

  get hasThemes(): boolean {
    return this.themes.length > 0;
  }

  taxonomyKeywordsLabel(theme: TaxonomyThemePayload): string {
    const kw = theme.keywords;
    if (!kw?.length) {
      return '';
    }
    return kw.join(', ');
  }

  subthemeKeywordsLabel(keywords: string[] | undefined): string {
    if (!keywords?.length) {
      return '';
    }
    return keywords.join(', ');
  }

  trackTheme(_index: number, theme: TaxonomyThemePayload): string {
    return theme.name;
  }

  trackSubtheme(_index: number, st: { name: string }): string {
    return st.name;
  }
}
